module.exports = __webpack_public_path__ + "static/christina-yacht-4-a0529bc9cb5143e9ac27c09f21f84bf2.jpg";